"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEntityDisabled = void 0;
var _getFileExtension = require("../../../utils/data/getFileExtension");
const isEntityDisabled = (entity, forbiddenRootFolderName, forbiddenExtensions) => {
  if (!entity) {
    return false;
  }
  const {
    fullPath
  } = entity;
  if (!fullPath) {
    return false;
  }
  const rootFolderPath = fullPath.split("/")[0];
  if (forbiddenRootFolderName.toLowerCase() !== rootFolderPath.toLowerCase()) {
    return false;
  }
  const fileExtension = (0, _getFileExtension.getFileExtension)(entity.fileName);
  return forbiddenExtensions.includes(fileExtension);
};
exports.isEntityDisabled = isEntityDisabled;
//# sourceMappingURL=isEntityDisabled.js.map